<div class="container-fluid px-1 px-md-3">
	<h1 class="my-3">Configuracion de Impresora USB</h1>

	<div class="card p-3 my-3">
		<h4>Datos de la Impresora</h4>

		<div class="row">
			<div class="col-12 col-md-6">
				<label class="form-label">Nombre</label>
				<input type="text" class="form-control" [(ngModel)]="printer.name" placeholder="Ej: Impresora Caja 1">
			</div>
			<div class="col-12 col-md-6">
				<label class="form-label">Sucursal</label>
				<select class="form-control" [(ngModel)]="printer.store_id">
					<option *ngFor="let store of store_list" [ngValue]="store.id">{{store.name}}</option>
				</select>
			</div>
		</div>

		<div class="row mt-3">
			<div class="col-12">
				<label class="form-label">Descripcion</label>
				<input type="text" class="form-control" [(ngModel)]="printer.description" placeholder="Descripcion opcional">
			</div>
		</div>
	</div>

	<div class="card p-3 my-3">
		<h4>Configuracion USB</h4>

		<div class="row mb-3">
			<div class="col-12">
				<label class="form-label">Impresoras Comunes (Seleccione para autocompletar)</label>
				<div class="d-flex flex-wrap gap-2">
					<button *ngFor="let preset of common_printers"
							type="button"
							class="btn btn-outline-secondary btn-sm"
							(click)="applyPreset(preset)">
						{{preset.name}}
					</button>
				</div>
			</div>
		</div>

		<div class="row">
			<div class="col-12 col-md-4">
				<label class="form-label">Vendor ID</label>
				<input type="text" class="form-control font-monospace" [(ngModel)]="printer.vendor_id" placeholder="0x1504">
				<small class="text-muted">Formato hexadecimal (ej: 0x1504)</small>
			</div>
			<div class="col-12 col-md-4">
				<label class="form-label">Product ID</label>
				<input type="text" class="form-control font-monospace" [(ngModel)]="printer.product_id" placeholder="0x003d">
				<small class="text-muted">Formato hexadecimal (ej: 0x003d)</small>
			</div>
			<div class="col-12 col-md-4">
				<label class="form-label">Numero de Serie (opcional)</label>
				<input type="text" class="form-control font-monospace" [(ngModel)]="printer.serial_number" placeholder="">
				<small class="text-muted">Para distinguir multiples impresoras iguales</small>
			</div>
		</div>

		<div class="row mt-3">
			<div class="col-12 col-md-4">
				<label class="form-label">Interface USB</label>
				<input type="number" class="form-control" [(ngModel)]="printer.interface_number" min="0" max="10">
				<small class="text-muted">Normalmente 0. Cambiar solo si hay problemas</small>
			</div>
		</div>
	</div>

	<div class="card p-3 my-3">
		<h4>Opciones de Impresion</h4>

		<div class="row">
			<div class="col-12 col-md-6">
				<label class="form-label">Estilo de Calculo</label>
				<select class="form-control" [(ngModel)]="printer.calculation_style">
					<option value="NORMAL">Normal - Usa valores almacenados</option>
					<option value="SAT_FACTURA">SAT Factura - CFDI 4.0 (valor unitario, descuento ajuste)</option>
				</select>
				<small class="text-muted">Como se calculan los valores del ticket</small>
			</div>
			<div class="col-12 col-md-6">
				<label class="form-label">Compactar Articulos</label>
				<div class="form-check form-switch mt-2">
					<input class="form-check-input" type="checkbox" id="compact_items" [(ngModel)]="printer.compact_items">
					<label class="form-check-label" for="compact_items">
						Agrupar articulos iguales
					</label>
				</div>
				<small class="text-muted">Une articulos con mismo nombre y precio en una linea</small>
			</div>
		</div>
	</div>

	<div class="card p-3 my-3">
		<h4>Configuracion del Ticket</h4>

		<div class="row">
			<div class="col-12 col-md-4">
				<label class="form-label">Modelo/Marca</label>
				<select class="form-control" [(ngModel)]="printer.model" (change)="updatePreview()">
					<option *ngFor="let model of printer_models" [value]="model.value">{{model.label}}</option>
				</select>
			</div>
			<div class="col-12 col-md-4">
				<label class="form-label">Mapeo de Caracteres</label>
				<select class="form-control" [(ngModel)]="printer.codepage_mapping" (change)="updatePreview()">
					<option *ngFor="let cp of codepage_mappings" [value]="cp.value">{{cp.label}}</option>
				</select>
			</div>
			<div class="col-12 col-md-4">
				<label class="form-label">Configuracion de Ticket</label>
				<select class="form-control" [(ngModel)]="printer.ticket_id">
					<option [ngValue]="0">-- Por defecto --</option>
					<option *ngFor="let ticket of ticket_list" [ngValue]="ticket.id">{{ticket.name}}</option>
				</select>
				<small class="text-muted">
					<a [routerLink]="['/list-ticket-config']">Administrar tickets</a>
				</small>
			</div>
		</div>

		<div class="row mt-3">
			<div class="col-12 col-md-4">
				<label class="form-label">Columnas</label>
				<input type="number" class="form-control" [(ngModel)]="printer.columns" min="20" max="80" (change)="updatePreview()">
				<small class="text-muted">Caracteres por linea</small>
			</div>
			<div class="col-12 col-md-4">
				<label class="form-label">Columnas Fuente A</label>
				<input type="number" class="form-control" [(ngModel)]="printer.font_a_columns" min="20" max="80">
				<small class="text-muted">Fuente normal (ej: 42)</small>
			</div>
			<div class="col-12 col-md-4">
				<label class="form-label">Columnas Fuente B</label>
				<input type="number" class="form-control" [(ngModel)]="printer.font_b_columns" min="20" max="80">
				<small class="text-muted">Fuente condensada (ej: 56)</small>
			</div>
		</div>
	</div>

	<div class="card p-3 my-3">
		<h4>Probar Impresora</h4>

		<div class="row">
			<div class="col-12 col-md-6">
				<div class="d-grid gap-2">
					<button type="button"
							class="btn btn-lg"
							[ngClass]="{
								'btn-primary': connection_status === 'disconnected',
								'btn-warning': connection_status === 'connecting',
								'btn-success': connection_status === 'connected',
								'btn-danger': connection_status === 'error'
							}"
							[disabled]="connection_status === 'connecting'"
							(click)="testConnection($event)">
						<span *ngIf="connection_status === 'disconnected'">Probar Conexion</span>
						<span *ngIf="connection_status === 'connecting'">Conectando...</span>
						<span *ngIf="connection_status === 'connected'">Conectado</span>
						<span *ngIf="connection_status === 'error'">Reintentar Conexion</span>
					</button>
					<small class="text-muted text-center" *ngIf="connection_message">{{connection_message}}</small>
				</div>
			</div>
			<div class="col-12 col-md-6">
				<div class="d-grid gap-2">
					<button type="button"
							class="btn btn-lg"
							[ngClass]="{
								'btn-secondary': print_status === 'idle',
								'btn-warning': print_status === 'printing',
								'btn-success': print_status === 'success',
								'btn-danger': print_status === 'error'
							}"
							[disabled]="print_status === 'printing'"
							(click)="printTestTicket($event)">
						<span *ngIf="print_status === 'idle'">Imprimir Ticket de Prueba</span>
						<span *ngIf="print_status === 'printing'">Imprimiendo...</span>
						<span *ngIf="print_status === 'success'">Impreso</span>
						<span *ngIf="print_status === 'error'">Reintentar Impresion</span>
					</button>
					<small class="text-muted text-center" *ngIf="print_message">{{print_message}}</small>
				</div>
			</div>
		</div>

		<div class="alert alert-info mt-3">
			<strong>Nota:</strong> La primera vez que conecte una impresora, el navegador le pedira permiso para acceder al dispositivo USB.
			Asegurese de seleccionar la impresora correcta en el dialogo que aparece.
		</div>
	</div>

	<div class="card p-3 my-3">
		<h4>Vista Previa del Ticket (XML)</h4>
		<textarea
			class="form-control bg-dark text-light font-monospace"
			[(ngModel)]="preview_xml"
			rows="15"
			style="resize: vertical;"
			placeholder="XML del ticket de prueba"></textarea>
		<small class="text-muted">Puede editar el XML para probar diferentes datos antes de imprimir</small>
	</div>

	<div class="row my-4">
		<div class="col-12">
			<div class="d-grid gap-2 d-md-flex justify-content-md-end">
				<button type="button" class="btn btn-secondary" (click)="location.back()">Cancelar</button>
				<button type="button" class="btn btn-primary btn-lg" (click)="save()" [disabled]="is_loading">
					<span *ngIf="is_loading">Guardando...</span>
					<span *ngIf="!is_loading">Guardar Configuracion</span>
				</button>
			</div>
		</div>
	</div>
</div>
